import { QUICK_POST_V3_FOOTER_TOOLBAR_PORTAL_ID } from "@circle-react/components/QuickPostV3/constants";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";

interface ToolbarProps {
  floating?: boolean;
  shrink?: boolean;
}

export const Toolbar = ({ shrink, floating }: ToolbarProps = {}) => (
  <nav
    aria-label={t("quick_post_v2.footer_menu_aria_label")}
    className={classNames(
      floating
        ? "absolute bottom-full left-6 z-20 pb-3"
        : "flex h-12 items-center [&_button]:size-8 [&_button]:rounded-md [&_li:not(.hidden)]:flex [&_li]:items-center [&_li]:justify-center [&_svg]:size-4 [&_ul]:gap-0",
      shrink && "shrink-0",
    )}
    id={QUICK_POST_V3_FOOTER_TOOLBAR_PORTAL_ID}
  />
);
